import React from 'react'

import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as instructorActions from '../../_actions/roster.actions'
import _ from 'lodash'
import BigCalendar from 'react-big-calendar'
import withDragAndDrop from 'react-big-calendar/lib/addons/dragAndDrop'
import RosterForm from '../etimeform/RosterForm'
import RosterPreview from '../etimeform/RosterPreview'
import { Menubar } from 'primereact/menubar'
import { Button } from 'primereact/button'
import { DndProvider } from 'react-dnd'
import TimeUtils from '../../utils/TimeUtils'
import { Dialog } from 'primereact/dialog'
import Filter from './Filter'
import ActionConfig from './actionConfig'
import ToolBar from './Toolbar'
import { Popover, Select, Collapse, Calendar, Modal } from 'antd'
import { toast } from 'react-toastify'
import WorkViewRoster from './WorkViewRoster'
import ColorCustomization from '../settings/theme/ColorCustomization'

import ManagerApproval from './ManagerApproval'
import RosterManagment from './RosterManagment'
import RosterTemplate from './RosterTemplate'
import Moment from 'moment'
import { extendMoment } from 'moment-range'
import { viewConstants } from '../../_constants/view.constants'

import './css/style.css'
import 'react-big-calendar/lib/addons/dragAndDrop/styles.css'

toast.configure()

const moment = extendMoment(Moment)
const localizer = BigCalendar.momentLocalizer(moment)
const DragAndDropCalendar = withDragAndDrop(BigCalendar, DndProvider)

const WHOLE_DAY = 86400000
const NORMALWORKING_ACTION = 99

class Rostering extends React.PureComponent {
    constructor(props) {
        super(props)
this.state = {
             currentMonth: new Date(),
             selectedDate: new Date(),
             showModal: false,
             event: {},
             events: [],
             employees: [],
             displayEvents: [],
             displayEmployees: [],
             showForm: false,
             formTitle: '',
             activeTab: '1',
             selectedBranch: {},
             selectedDepartment: {},
             mounted: false,
             showLegend: false,
             clicked: false,
             hovered: false,
             content: 'roster',
             openFilterDrawer: false,
             modalActionType: '',
             showFilters: true,
             showWeekFilters: true,
         }

        this.target = React.createRef()
    }

    componentDidMount() {
        const { events, selectedEmployee } = this.props
        if (events != undefined && events.length == 0) {
            this.props.actions.fetchUserETime()
        }

        if (!_.isEmpty(selectedEmployee)) {
            const filteredEvents = _.filter(events, function(evt) {
                return evt.EmployeeID === selectedEmployee
            })

            this.setState({
                displayEvents: filteredEvents,
            })
        }

        this.setState({ mounted: true })
    }

    handleHoverChange = visible => {
        this.setState({
            hovered: visible,
            clicked: false,
        })
    }

    handleClickChange = visible => {
        this.setState({
            clicked: visible,
            hovered: false,
        })
    }

    resetEvents = (currentEmployee, filteredEmployees) => {
        const selected = _.find(filteredEmployees, {
            EmployeeID: currentEmployee,
        })

        if (_.isEmpty(selected)) {
            this.props.actions.selectEmployee('')
            this.setState({ displayEvents: [] })
        }
    }

    filterEvents = employeeID => {
        const { events } = this.props
        const filteredEvents = _.filter(events, function(evt) {
            return evt.EmployeeID === employeeID
        })

        this.setState({
            displayEvents: filteredEvents,
        })
    }

    onFormHide = () => {
        this.setState({ modalActionType: '' })
    }

    moveEvent = ({ event, start, end, isAllDay: droppedOnAllDaySlot }) => {
        let allDay = event.allDay

        if (event.source === 'timesheet') {
            toast.warning('Read only event!', { position: 'top-center' })
            return
        }

        if (!event.allDay && droppedOnAllDaySlot) {
            allDay = true
        } else if (event.allDay && !droppedOnAllDaySlot) {
            allDay = false
        }

        const updatedEvent = { ...event, start, end, allDay }
        this.props.actions.updateEvent(updatedEvent, this.props.selectedEmployee)
    }

    copyEvent = ({ event, start, end }) => {
        let data = { id: event.id, start, end }
        this.props.actions.copyInsertEvents(data)
    }

    handleSelectSlot = e => {
        if (!_.isEmpty(this.props.selectedEmployees)) {
            this.newEvent(e)
        }
    }

    newEvent = event => {
        let eTimeRequest = {
            id: '',
            title: '',
            actionType: { label: 'Normal working', value: NORMALWORKING_ACTION },
            allDay: event.slots.length == 1,
            dateFrom: event.start,
            dateTo: event.slots.length > 1 ? event.end : undefined,
            draggable: true,
            status: 0,
            startTime: '09:00',
            endTime: '17:30',
            duration: '',
            break: event.break || '0',
            note: '',
            existing: false,
        }
        this.setState({ event: eTimeRequest, modalActionType: 'create' })
    }

    customColorEventPropGetter = event => {
        return { style: { backgroundColor: event.Status ? '#1169aa' : '#5FC462' } }
    }

    renderEvetDetail = event => {
        let eTimeRequest = {
            id: event.id,
            title: event.Title || event.title,
            actionType: _.find(this.props.actionTypes, { value: event.ActionType }),
            allDay: event.allDay,
            dateFrom: event.start,
            startTime: TimeUtils.extractTime(event.start),
            endTime: event.end ? TimeUtils.extractTime(event.end) : '17:30',
            duration: event.ActionHours || '',
            break: event.Break || 0,
            Note: event.Note || '',
            existing: true,
            status: event.Status,
            employeeID: event.EmployeeID,
            EmployeeName: event.EmployeeName,
            hours: event.hours || 0,
            source: event.source,
        }

        this.setState({ event: eTimeRequest, modalActionType: 'update' })
    }

    filterDisplayEvents = () => {
        return _.map(this.props.displayEvents || [], obj => obj)
    }

    toggleFilters = () => {
        this.setState(prevState => {
            const newShowFilters = !prevState.showFilters
            // If in weekly view, also update showWeekFilters
            if (prevState.content === 'weekly') {
                return { showFilters: newShowFilters, showWeekFilters: newShowFilters }
            }
            return { showFilters: newShowFilters }
        })
    }

    hasActiveFilters = () => {
        const { selectedEmployees, selectedBranches, selectedDepartments, hasActiveDateRangeFilter } = this.props
        return !!(selectedEmployees?.length > 0 || selectedBranches?.length > 0 || selectedDepartments?.length > 0 || hasActiveDateRangeFilter)
    }

    onLegendHide = () => {
        this.setState({ showLegend: false })
    }

    handleOnView = view => {
        if (view === 'week') {
            this.setState({ content: 'weekly', showFilters: this.state.showWeekFilters })
            const options = { range: viewConstants.WEEK, time: new Date() }
            this.props.actions.fetchUserETime(options)
        } else {
            this.props.actions.fetchUserETime()
            this.setState({ content: 'roster' })
        }

        this.props.actions.selectEmployee('')
        this.props.actions.selectEmployees([])
        this.props.actions.selectBranches([])
        this.props.actions.selectDepartments([])
        this.props.actions.selectDateRangeFilter({ startDate: null, endDate: null, hasActive: false })
    }

    getMenuItems = () => {
        return [
            {
                label: 'View',
                icon: 'pi pi-fw pi-eye',
                items: [
                    {
                        label: 'Week',
                        command: () => this.handleOnView('week'),
                    },
                    { separator: true },
                    {
                        label: 'Calendar',
                        command: () => this.handleOnView('month'),
                    },
                ],
            },
        ]
    }

    renderToolbar = (props) => {
        const legend = <div><ColorCustomization /></div>
        const endElement = (
            <Popover
                style={{ maxWidth: '400px' }}
                content={legend}
                trigger="hover"
                open={this.state.hovered}
                onOpenChange={this.handleHoverChange}
            >
                <Button label="Legend" className="p-button-raised p-button-info p-button-text" />
            </Popover>
        )

        return (
            <ToolBar
                {...props}
                showFilters={this.state.showFilters}
                onToggleFilters={this.toggleFilters}
                hasActiveFilters={this.hasActiveFilters()}
                menuItems={this.getMenuItems()}
                // endElement={endElement}
                onView={this.handleOnView}
            >
                <Filter
                    view={this.state.content === 'weekly' ? 'week' : 'month'}
                    horizontal={true}
                    filterEvents={this.filterEvents}
                    resetEvents={this.resetEvents}
                />
            </ToolBar>
        )
    }

    components = {
        toolbar: this.renderToolbar,
    }

    render() {
        const { content } = this.state

        const rosterContent = (
            <div className="roster-content">
                <div className="calendar-panel">
                    <div className="panel">
                        <div className="panel-body">
                            <div className="calendar">
                                <div className="roster m-2">
                                    <DragAndDropCalendar
                                        popup
                                        selectable
                                        localizer={localizer}
                                        events={this.filterDisplayEvents()}
                                        onEventDrop={this.moveEvent}
                                        resizable
                                        onEventResize={this.copyEvent}
                                        onSelectEvent={this.renderEvetDetail}
                                        onSelectSlot={this.handleSelectSlot}
                                        views={['month']}
                                        defaultView={BigCalendar.Views.MONTH}
                                        defaultDate={this.props.currentDate}
                                        eventPropGetter={this.customColorEventPropGetter}
                                        titleAccessor="Title"
                                        startAccessor="start"
                                        endAccessor="end"
                                        showMultiDayTimes={true}
                                        draggableAccessor="draggable"
                                        culture="en-NZ"
                                        tooltipAccessor="Title"
                                        classNameCustom="rbc-calendar"
                                        components={this.components}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )

const weeklyView = (
             <WorkViewRoster
                 actions={this.props.actions}
                 showWeekFilters={this.state.showWeekFilters}
                 onViewChange={viewContent => {
                     setTimeout(() => {
                         this.setState({ content: viewContent })
                     }, 0)
                 }}
                 components={this.components}
                 onToggleWeekFilters={() => this.setState(prevState => ({ showWeekFilters: !prevState.showWeekFilters }))}
             />
         )

        return (
            <div className="">
                {content === 'roster' && rosterContent}
                {content === 'manager' && <RosterManagment />}
                {content === 'template' && <RosterTemplate />}
                {content === 'weekly' && weeklyView}
                
                <Dialog
                    header="Color"
                    visible={this.state.showLegend}
                    onHide={this.onLegendHide}
                    maximized={false}
                    maximizable={true}
                >
                    <ColorCustomization />
                </Dialog>

                <Dialog
                    header="Create roster"
                    visible={this.state.modalActionType === 'create'}
                    onHide={this.onFormHide}
                    maximizable={true}
                    resizable={true}
                    breakpoints={{ '960px': '75vw', '640px': '100vw' }}
                    style={{ width: '50vw' }}
                >
                    <RosterForm
                        event={this.state.event}
                        renderContent="roster"
                        selectedEmployees={this.props.selectedEmployees}
                        actionTypes={this.props.actionTypes}
                        showEmployee={true}
                        onHide={this.onFormHide}
                    />
                </Dialog>

                 {this.state.modalActionType === 'update' && (
                     <RosterPreview
                         event={this.state.event}
                         onClose={this.onFormHide}
                         employees={this.props.displayEmployees}
                     />
                 )}

            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        currentDate: state.roster.currentDate,
        events: state.roster.events,
        displayEvents: state.roster.displayEvents,
        displayEmployees: state.roster.displayEmployees,
        selectedEmployee: state.roster.selectedEmployee,
        selectedEmployees: state.roster.selectedEmployees,
        selectedBranches: state.roster.selectedBranches,
        selectedDepartments: state.roster.selectedDepartments,
        hasActiveDateRangeFilter: state.roster.hasActiveDateRangeFilter,
        actionTypes: state.ActionTypesReducer.actionTypes,
        payrollDefaultWorkHour: state.payrollDefaultWorkHour,
        payrollNormalWorkHour: state.payrollNormalWorkHour,
        colors: state.colors.colors,
    }
}

function mapDispatchToProps(dispatch) {
    return { actions: bindActionCreators(instructorActions, dispatch) }
}

export default connect(mapStateToProps, mapDispatchToProps)(Rostering)
